var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0"},[_c('p',{staticClass:"section-title mt-4"},[_vm._v("Nominated out-of-area schools")]),_vm._l((_vm.ooaHighSchools),function(school,index){return _c('v-row',{key:index},[_c('ReviewField',{attrs:{"sm":"10","label":`Nominated school ${index + 1}`,"value":school.schoolName}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }